package core.enums

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 25.11.20
 * Author : leonhergt
 */
enum class ESponsor(val mId: Int, val mName: String) {

    BANNER(1, "banner"),
    TIMELINE(2,"timeline"),
    NEWS(3,"news"),
    SCHEDULE(4,"schedule"),
    GAME_OVERVIEW(5,"gameoverview"),
    GAME_DETAIL(6,"gamedetail"),
    TABLE(7,"table"),
    TEAM(8,"team"),
    WEBSITE(9,"website-schedule"),
    LIGHTSHOW(10,"lightshow")

    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}